import { useParams } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";

import { usePlayerProfileStore } from "@/stores/player-profile";

import { HitterCharts } from "./HitterCharts";
import { PitcherCharts } from "./PitcherCharts";

export const Charts = () => {
  const { id: playerExternalId } = useParams() as { id: string };

  const { playerType } = usePlayerProfileStore(
    useShallow((state) => ({
      playerType: state.playerType,
    })),
  );

  if (playerType === "pitcher") {
    return <PitcherCharts playerExternalId={playerExternalId} />;
  }

  return <HitterCharts playerExternalId={playerExternalId} />;
};
